/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
'use strict'

var $protobuf = require('protobufjs/light')

var $root = ($protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root()))
  .addJSON({
    com: {
      nested: {
        yhub: {
          nested: {
            pb: {
              options: {
                java_outer_classname: 'ApiProtobufV1'
              },
              nested: {
                Location: {
                  fields: {
                    gnssLong: {
                      type: 'double',
                      id: 1
                    },
                    gnssLat: {
                      type: 'double',
                      id: 2
                    },
                    lbsLong: {
                      type: 'double',
                      id: 3
                    },
                    lbsLat: {
                      type: 'double',
                      id: 4
                    },
                    yhubStime: {
                      type: 'int64',
                      id: 5
                    }
                  }
                },
                APIGetGNSSLocation: {
                  fields: {
                    location: {
                      rule: 'repeated',
                      type: 'Location',
                      id: 1
                    }
                  }
                },
                Trace: {
                  fields: {
                    gnssLong: {
                      type: 'double',
                      id: 1
                    },
                    gnssLat: {
                      type: 'double',
                      id: 2
                    },
                    yhubStime: {
                      type: 'int64',
                      id: 3
                    },
                    hdop: {
                      type: 'double',
                      id: 4
                    },
                    altitude: {
                      type: 'double',
                      id: 5
                    },
                    cog: {
                      type: 'double',
                      id: 6
                    },
                    spkm: {
                      type: 'double',
                      id: 7
                    },
                    gpsLocationLong: {
                      type: 'double',
                      id: 8
                    },
                    gpsLocationLat: {
                      type: 'double',
                      id: 9
                    }
                  }
                },
                APIGetGNSSTrace: {
                  fields: {
                    trace: {
                      rule: 'repeated',
                      type: 'Trace',
                      id: 1
                    }
                  }
                },
                MsgBMSData: {
                  fields: {
                    batTotalVol: {
                      type: 'double',
                      id: 1
                    },
                    batTotalCur: {
                      type: 'double',
                      id: 2
                    },
                    bat_SOC: {
                      type: 'double',
                      id: 3
                    },
                    temp1: {
                      type: 'double',
                      id: 4
                    },
                    temp2: {
                      type: 'double',
                      id: 5
                    },
                    usedah: {
                      type: 'double',
                      id: 6
                    },
                    chargedah: {
                      type: 'double',
                      id: 7
                    },
                    yhubStime: {
                      type: 'int64',
                      id: 8
                    }
                  }
                },
                APIGetMsgBMSData: {
                  fields: {
                    msgBMSData: {
                      rule: 'repeated',
                      type: 'MsgBMSData',
                      id: 1
                    }
                  }
                },
                APIChargerInfo: {
                  fields: {
                    chargerInfos: {
                      rule: 'repeated',
                      type: 'ChargerInfo',
                      id: 1
                    }
                  }
                },
                ChargerInfo: {
                  fields: {
                    outputVoltage: {
                      type: 'uint32',
                      id: 1
                    },
                    outputCurrent: {
                      type: 'uint32',
                      id: 2
                    },
                    current_Ah: {
                      type: 'uint32',
                      id: 3
                    },
                    errorInfo: {
                      type: 'string',
                      id: 4
                    },
                    chargerStage: {
                      type: 'uint32',
                      id: 5
                    },
                    chargerTemperature: {
                      type: 'int32',
                      id: 6
                    },
                    libatteryTemperature: {
                      type: 'int32',
                      id: 7
                    },
                    supplyVoltage: {
                      type: 'uint32',
                      id: 8
                    },
                    supplyFrequence: {
                      type: 'uint32',
                      id: 9
                    },
                    chargerMode: {
                      type: 'uint32',
                      id: 10
                    },
                    chargerStatus: {
                      type: 'uint32',
                      id: 11
                    },
                    chargerNetStatus: {
                      type: 'bool',
                      id: 12
                    },
                    curveNum: {
                      type: 'uint32',
                      id: 13
                    },
                    chargerFwVersion: {
                      type: 'uint32',
                      id: 14
                    },
                    yhubStime: {
                      type: 'int64',
                      id: 15
                    },
                    chargerId: {
                      type: 'string',
                      id: 16
                    }
                  }
                },
                APIMsgBMSData: {
                  fields: {
                    msgBMSFullDatas: {
                      rule: 'repeated',
                      type: 'MsgBMSFullData',
                      id: 1
                    }
                  }
                },
                MsgBMSFullData: {
                  fields: {
                    temperature: {
                      type: 'MsgBMS2MeterTempFrame',
                      id: 1
                    },
                    singlevol: {
                      type: 'MsgBMS2MeterFrame',
                      id: 2
                    },
                    BMS2CarFrame1: {
                      type: 'MsgBMS2CarFrame1',
                      id: 3
                    },
                    BMS2CarFrame2: {
                      type: 'MsgBMS2CarFrame2',
                      id: 4
                    },
                    BMS2CarFrame3: {
                      type: 'MsgBMS2CarFrame3',
                      id: 5
                    },
                    BMS2CarFrame4: {
                      type: 'MsgBMS2CarFrame4',
                      id: 6
                    },
                    yhubTime: {
                      type: 'int64',
                      id: 7
                    },
                    mcuId: {
                      type: 'string',
                      id: 8
                    },
                    usedah: {
                      type: 'uint32',
                      id: 9
                    },
                    chargedah: {
                      type: 'uint32',
                      id: 10
                    }
                  }
                },
                MsgBMS2MeterTempFrame: {
                  fields: {
                    temperature: {
                      rule: 'repeated',
                      type: 'int32',
                      id: 1
                    }
                  }
                },
                MsgBMS2MeterFrame: {
                  fields: {
                    singlevol: {
                      rule: 'repeated',
                      type: 'uint32',
                      id: 1
                    }
                  }
                },
                MsgBMS2CarFrame1: {
                  fields: {
                    batTotalVol: {
                      type: 'uint32',
                      id: 1
                    },
                    batTotalCur: {
                      type: 'int32',
                      id: 2
                    },
                    bat_SOC: {
                      type: 'uint32',
                      id: 3
                    },
                    sys_Status1: {
                      type: 'uint32',
                      id: 4
                    },
                    sys_Status2: {
                      type: 'uint32',
                      id: 5
                    },
                    sys_Status3: {
                      type: 'uint32',
                      id: 6
                    }
                  }
                },
                MsgBMS2CarFrame2: {
                  fields: {
                    singleVoltageMax: {
                      type: 'uint32',
                      id: 1
                    },
                    batSerialNumberMax: {
                      type: 'uint32',
                      id: 2
                    },
                    singleVoltageMin: {
                      type: 'uint32',
                      id: 3
                    },
                    batSerialNumberMin: {
                      type: 'uint32',
                      id: 4
                    }
                  }
                },
                MsgBMS2CarFrame3: {
                  fields: {
                    temperatureMax: {
                      type: 'int32',
                      id: 1
                    },
                    batSerialNumberMax: {
                      type: 'uint32',
                      id: 2
                    },
                    temperatureMin: {
                      type: 'int32',
                      id: 3
                    },
                    batSerialNumberMin: {
                      type: 'uint32',
                      id: 4
                    },
                    PInsulation: {
                      type: 'uint32',
                      id: 5
                    },
                    NInsulation: {
                      type: 'uint32',
                      id: 6
                    }
                  }
                },
                MsgBMS2CarFrame4: {
                  fields: {
                    sys_Status3: {
                      type: 'uint32',
                      id: 1
                    },
                    BMS_InputVol_ACC: {
                      type: 'uint32',
                      id: 2
                    },
                    BMS_InputVol_KEYON: {
                      type: 'uint32',
                      id: 3
                    },
                    BMS_InputVol_CHG: {
                      type: 'uint32',
                      id: 4
                    }
                  }
                },
                APIMsgInverterData: {
                  fields: {
                    msgInverterDatas: {
                      rule: 'repeated',
                      type: 'MsgInverterData',
                      id: 1
                    }
                  }
                },
                MsgInverterData: {
                  fields: {
                    batVoltage: {
                      type: 'double',
                      id: 1
                    },
                    batCurrent: {
                      type: 'double',
                      id: 2
                    },
                    inverterOutVol: {
                      type: 'double',
                      id: 3
                    },
                    inverterOutCur: {
                      type: 'double',
                      id: 4
                    },
                    inverterTemperature: {
                      type: 'double',
                      id: 5
                    },
                    errorCode: {
                      type: 'uint32',
                      id: 6
                    },
                    triggerTime: {
                      type: 'int64',
                      id: 7
                    },
                    inverterID: {
                      type: 'string',
                      id: 8
                    },
                    invOutputPower: {
                      type: 'int32',
                      id: 9
                    }
                  }
                },
                APIMsgCBBcloud: {
                  fields: {
                    msgCBBcloud: {
                      rule: 'repeated',
                      type: 'MsgCBBcloud',
                      id: 1
                    }
                  }
                },
                MsgCBBcloud: {
                  fields: {
                    batV: {
                      type: 'int32',
                      id: 1
                    },
                    batI: {
                      type: 'int32',
                      id: 2
                    },
                    inverterV: {
                      type: 'int32',
                      id: 3
                    },
                    inverterI: {
                      type: 'int32',
                      id: 4
                    },
                    inverterPower: {
                      type: 'int32',
                      id: 5
                    },
                    errorCode: {
                      type: 'int32',
                      id: 6
                    },
                    triggerTime: {
                      type: 'int64',
                      id: 7
                    },
                    cbbID: {
                      type: 'string',
                      id: 8
                    }
                  }
                },
                APIMsgDMTcloud: {
                  fields: {
                    msgDMTcloud: {
                      rule: 'repeated',
                      type: 'MsgDMTcloud',
                      id: 1
                    }
                  }
                },
                MsgDMTcloud: {
                  fields: {
                    batInputV: {
                      type: 'int32',
                      id: 1
                    },
                    pvInputV: {
                      type: 'int32',
                      id: 2
                    },
                    outputV: {
                      type: 'int32',
                      id: 3
                    },
                    outputI: {
                      type: 'int32',
                      id: 4
                    },
                    mpptPower: {
                      type: 'int32',
                      id: 5
                    },
                    errorStatus: {
                      type: 'int32',
                      id: 6
                    },
                    triggerTime: {
                      type: 'int64',
                      id: 7
                    },
                    dmtID: {
                      type: 'string',
                      id: 8
                    },
                    inputI: {
                      type: 'int32',
                      id: 9
                    },
                    deviceTemperature: {
                      type: 'int32',
                      id: 10
                    },
                    batteryTemperature: {
                      type: 'int32',
                      id: 11
                    }
                  }
                },
                APIMsgTCcloud: {
                  fields: {
                    msgTCcloud: {
                      rule: 'repeated',
                      type: 'MsgTCcloud',
                      id: 1
                    }
                  }
                },
                MsgTCcloud: {
                  fields: {
                    AC_V: {
                      type: 'int32',
                      id: 1
                    },
                    charge_I: {
                      type: 'int32',
                      id: 2
                    },
                    envTemp: {
                      type: 'int32',
                      id: 3
                    },
                    btsTemp: {
                      type: 'int32',
                      id: 4
                    },
                    CH1_V: {
                      type: 'int32',
                      id: 5
                    },
                    CH2_V: {
                      type: 'int32',
                      id: 6
                    },
                    CH3_V: {
                      type: 'int32',
                      id: 7
                    },
                    triggerTime: {
                      type: 'int64',
                      id: 8
                    },
                    tcID: {
                      type: 'string',
                      id: 9
                    }
                  }
                },
                APIMsgEnerDriveBatData: {
                  fields: {
                    msgEnerDriveBatData: {
                      rule: 'repeated',
                      type: 'MsgEnerDriveBatData',
                      id: 1
                    }
                  }
                },
                MsgEnerDriveBatData: {
                  fields: {
                    current: {
                      type: 'int32',
                      id: 1
                    },
                    voltage: {
                      type: 'int32',
                      id: 2
                    },
                    rsoc: {
                      type: 'int32',
                      id: 3
                    },
                    remainAh: {
                      type: 'int32',
                      id: 4
                    },
                    timestamp: {
                      type: 'int64',
                      id: 5
                    },
                    temperature: {
                      type: 'int64',
                      id: 6
                    }
                  }
                },
                APIRecordDatas: {
                  fields: {
                    recordData: {
                      rule: 'repeated',
                      type: 'RecordData',
                      id: 1
                    }
                  }
                },
                RecordData: {
                  fields: {
                    cycleId: {
                      type: 'uint32',
                      id: 1
                    },
                    time: {
                      type: 'int64',
                      id: 2
                    },
                    ChargingCurrent: {
                      type: 'uint32',
                      id: 3
                    },
                    DisChargingCurrent: {
                      type: 'uint32',
                      id: 4
                    },
                    voltage: {
                      type: 'uint32',
                      id: 5
                    },
                    BatteryTemperature: {
                      type: 'int32',
                      id: 6
                    },
                    TotalChargedAh: {
                      type: 'uint32',
                      id: 7
                    },
                    TotalDisChargedAh: {
                      type: 'uint32',
                      id: 8
                    },
                    soc: {
                      type: 'uint32',
                      id: 9
                    },
                    ignitionVol: {
                      type: 'uint32',
                      id: 10
                    },
                    hourMeterVol: {
                      type: 'uint32',
                      id: 11
                    },
                    auxBatVol: {
                      type: 'uint32',
                      id: 12
                    },
                    auxCurrent: {
                      type: 'int32',
                      id: 13
                    },
                    auxSoc: {
                      type: 'uint32',
                      id: 14
                    },
                    usingWh: {
                      type: 'uint32',
                      id: 15
                    },
                    chargingWh: {
                      type: 'uint32',
                      id: 16
                    },
                    socVolt: {
                      type: 'uint32',
                      id: 17
                    },
                    event: {
                      type: 'uint32',
                      id: 18
                    }
                  }
                },
                APIBMSRecord: {
                  fields: {
                    bmsRecord: {
                      rule: 'repeated',
                      type: 'BMSRecord',
                      id: 1
                    }
                  }
                },
                BMSRecord: {
                  fields: {
                    cycleID: {
                      type: 'int64',
                      id: 1
                    },
                    sstamp: {
                      type: 'uint32',
                      id: 2
                    },
                    mstamp: {
                      type: 'uint32',
                      id: 3
                    },
                    batteryVoltage: {
                      type: 'uint32',
                      id: 4
                    },
                    current: {
                      type: 'int32',
                      id: 5
                    },
                    soc: {
                      type: 'uint32',
                      id: 6
                    },
                    singleVol: {
                      type: 'string',
                      id: 7
                    },
                    temperature: {
                      type: 'string',
                      id: 8
                    },
                    usedAh: {
                      type: 'int64',
                      id: 9
                    },
                    chargingAh: {
                      type: 'int64',
                      id: 10
                    },
                    vol_ACC: {
                      type: 'uint32',
                      id: 11
                    },
                    vol_KEYON: {
                      type: 'uint32',
                      id: 12
                    },
                    vol_CHG: {
                      type: 'uint32',
                      id: 13
                    },
                    yhubTime: {
                      type: 'int64',
                      id: 14
                    },
                    usingWh: {
                      type: 'uint32',
                      id: 15
                    },
                    chargingWh: {
                      type: 'uint32',
                      id: 16
                    }
                  }
                },
                MsgUpsData: {
                  fields: {
                    statusBMS: {
                      type: 'uint32',
                      id: 1
                    },
                    stateOfChg: {
                      type: 'uint32',
                      id: 2
                    },
                    remainingTime: {
                      type: 'uint32',
                      id: 3
                    },
                    heatingTemp: {
                      type: 'int32',
                      id: 4
                    },
                    batTemp: {
                      type: 'int32',
                      id: 5
                    },
                    cellTempOne: {
                      type: 'int32',
                      id: 6
                    },
                    cellTempTwo: {
                      type: 'int32',
                      id: 7
                    },
                    cellTempThree: {
                      type: 'int32',
                      id: 8
                    },
                    batPackTemp: {
                      type: 'int32',
                      id: 9
                    },
                    AmbientTemp: {
                      type: 'int32',
                      id: 10
                    },
                    totalOfChg: {
                      type: 'uint32',
                      id: 11
                    },
                    totalOfDischg: {
                      type: 'uint32',
                      id: 12
                    },
                    batPackStauts: {
                      type: 'uint32',
                      id: 13
                    },
                    batPackStautsSecond: {
                      type: 'uint32',
                      id: 14
                    },
                    SOH: {
                      type: 'uint32',
                      id: 15
                    },
                    currentlyVol: {
                      type: 'uint32',
                      id: 16
                    },
                    currentlyCur: {
                      type: 'uint32',
                      id: 17
                    },
                    triggerTime: {
                      type: 'uint64',
                      id: 18
                    },
                    upsId: {
                      type: 'string',
                      id: 19
                    }
                  }
                },
                APIMsgUpsData: {
                  fields: {
                    upsData: {
                      rule: 'repeated',
                      type: 'MsgUpsData',
                      id: 1
                    }
                  }
                },
                NotifyPushMsg: {
                  fields: {
                    msgType: {
                      type: 'uint32',
                      id: 1
                    },
                    triggerValue: {
                      type: 'double',
                      id: 2
                    },
                    triggerSubValue: {
                      type: 'string',
                      id: 3
                    },
                    status: {
                      type: 'uint32',
                      id: 4
                    },
                    createTime: {
                      type: 'int64',
                      id: 5
                    },
                    updateTime: {
                      type: 'int64',
                      id: 6
                    },
                    delFlag: {
                      type: 'uint32',
                      id: 7
                    },
                    dtype: {
                      type: 'uint32',
                      id: 8
                    },
                    workStatus: {
                      type: 'uint32',
                      id: 9
                    },
                    extendValue: {
                      type: 'string',
                      id: 10
                    },
                    level: {
                      type: 'int32',
                      id: 11
                    }
                  }
                },
                NotifyRealTimeData: {
                  fields: {
                    rsrp: {
                      type: 'int32',
                      id: 1
                    },
                    yhubStimeTs: {
                      type: 'int64',
                      id: 2
                    },
                    batteryTemperature: {
                      type: 'int32',
                      id: 3
                    },
                    currentCharging: {
                      type: 'uint32',
                      id: 4
                    },
                    currentUsing: {
                      type: 'uint32',
                      id: 5
                    },
                    soc: {
                      type: 'uint32',
                      id: 6
                    },
                    voltageRaw: {
                      type: 'uint32',
                      id: 7
                    },
                    waterLevel: {
                      type: 'int32',
                      id: 8
                    },
                    relayStatus: {
                      type: 'bool',
                      id: 9
                    },
                    ignitionVol: {
                      type: 'uint32',
                      id: 10
                    },
                    hourMeterVol: {
                      type: 'uint32',
                      id: 11
                    },
                    auxBatVol: {
                      type: 'uint32',
                      id: 12
                    },
                    auxCurrent: {
                      type: 'int32',
                      id: 13
                    },
                    remainingAvailableTime: {
                      type: 'uint32',
                      id: 14
                    },
                    bmsRecord: {
                      type: 'string',
                      id: 15
                    }
                  }
                },
                APINotifyRecord: {
                  fields: {
                    mcuId: {
                      type: 'string',
                      id: 1
                    },
                    deviceName: {
                      type: 'string',
                      id: 2
                    },
                    realTimeData: {
                      type: 'NotifyRealTimeData',
                      id: 3
                    },
                    pushMsg: {
                      type: 'NotifyPushMsg',
                      id: 4
                    }
                  }
                },
                APIResponse: {
                  oneofs: {
                    payload: {
                      oneof: [
                        'gnssLocations',
                        'gnssTrace',
                        'gnssMsgBMSData',
                        'chargerInfo',
                        'msgBMSData',
                        'msgInverterData',
                        'recordDatas',
                        'bmsRecord',
                        'notifyRecord',
                        'msgCBBcloud',
                        'msgDMTcloud',
                        'msgTCcloud',
                        'msgEnerDriveBatData',
                        'msgUpsData'
                      ]
                    }
                  },
                  fields: {
                    resultCode: {
                      type: 'int32',
                      id: 1
                    },
                    resultMessage: {
                      type: 'string',
                      id: 2
                    },
                    gnssLocations: {
                      type: 'APIGetGNSSLocation',
                      id: 3
                    },
                    gnssTrace: {
                      type: 'APIGetGNSSTrace',
                      id: 4
                    },
                    gnssMsgBMSData: {
                      type: 'APIGetMsgBMSData',
                      id: 5
                    },
                    chargerInfo: {
                      type: 'APIChargerInfo',
                      id: 6
                    },
                    msgBMSData: {
                      type: 'APIMsgBMSData',
                      id: 7
                    },
                    msgInverterData: {
                      type: 'APIMsgInverterData',
                      id: 8
                    },
                    recordDatas: {
                      type: 'APIRecordDatas',
                      id: 9
                    },
                    bmsRecord: {
                      type: 'APIBMSRecord',
                      id: 10
                    },
                    notifyRecord: {
                      type: 'APINotifyRecord',
                      id: 11
                    },
                    msgCBBcloud: {
                      type: 'APIMsgCBBcloud',
                      id: 12
                    },
                    msgDMTcloud: {
                      type: 'APIMsgDMTcloud',
                      id: 13
                    },
                    msgTCcloud: {
                      type: 'APIMsgTCcloud',
                      id: 14
                    },
                    msgEnerDriveBatData: {
                      type: 'APIMsgEnerDriveBatData',
                      id: 15
                    },
                    msgUpsData: {
                      type: 'APIMsgUpsData',
                      id: 16
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  })

module.exports = $root
